import request from '@/utils/request';
export function postAddTogether(data) {
    return request({
        url: `/fund/together/add`,
        method: 'post',
        data
    });
}
export function getTogetherInfo(togetherId) {
    return request({
        url: `/fund/together/detail/${togetherId}`,
        method: 'get',
    });
}
export function closeTogether(data) {
    return request({
        url: `/fund/together/status`,
        method: 'post',
        data
    });
}
export function togetherList(params) {
    return request({
        url: `/fund/together/list`,
        method: 'get',
        params
    });
}
export function togetherMyList(params) {
    return request({
        url: `/fund/together/my-list`,
        method: 'get',
        params
    });
}
export function getTogetherAll(params) {
    return request({
        url: `/fund/together/all`,
        method: 'get',
        params
    });
}
